
import $ from "jquery"
import Promise from "plugins/bluebird/index"
import "plugins/jquery_plugins/prettierdate"
import "plugins/jquery_plugins/simple-ticker"

import log from "plugins/loglevel/index"

import MarketNews from "app/market_news/index"
import circularise from "app/utils/circularise"
import template_generator from "app/utils/template_generator"
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"

import {
  WPJsonData,
} from "components/market_news/wp_json_data"

const DEBUG_ENABLED = true
const debug = (msg: string) => {
  if (DEBUG_ENABLED) log.debug(msg)
}

// Number of news which should be ticking
// const MAX_TICKING = 7 //unused?
const MARKET_NEWS_TICKER_INTERVAL = 4000
// const MARKET_NEWS_TICKER_FADE_OUT_INTERVAL = 300//unused?
// const MARKET_NEWS_TICKER_FADE_IN_INTERVAL = 300 //unused?

interface Selector {
  main:       string | Element | JQuery,
  text_area:  Array<string | Element | JQuery>
  image_area: Array<string | Element | JQuery>
}
interface InputSelector {
  main?:       string | Element | JQuery,
  text_area?:  Array<string | Element | JQuery>
  image_area?: Array<string | Element | JQuery>
}
const DEFAULT_SELECTOR = {
  main: ".page-section--overseas-properties--content--news",

  text_area: [
    ".page-section--overseas-properties--content--featured-text-1",
    ".page-section--overseas-properties--content--featured-text-2",
  ],

  image_area: [
    ".page-section--overseas-properties--content--featured-image-1",
    ".page-section--overseas-properties--content--featured-image-2",
  ],
}
const HIDDEN_CLASS = "oversea-index--hidden"

const image_tmpl = ["#hb-oversea-news-featured-image-1", "#hb-oversea-news-featured-image-2"]
const text_tmpl = ["#hb-oversea-news-headline-link-1", "#hb-oversea-news-headline-link-2"]

const replace_element = (slot_el: string | Element | JQuery, template_id: string, data: object) => {
  const original_elem = $(slot_el)

  if (original_elem.length === 0) { return }

  const compile = template_generator.by_domid(template_id)
  const new_elem = $(compile(data)).hide()
  original_elem.replaceWith(new_elem)
  new_elem.show()
}

class MarketNewsTicketSection {
  protected selector: Selector
  protected $el: JQuery
  protected wp_ticker_api = ""

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$el = $(this.selector.main)

    this.created()
  }

  protected created(){
    this.search(MarketNews.OVERSEA_TAG)
    .then(() => {
      this.fetch()
    })

    return this
  }


  protected search(category: string){
    return q_ajax_3({
      url: MarketNews.tags_api_uri().search({
        slug: category,
      }).toString(),
      method:   "GET",
      // To remove default headers
      headers:  {},
    })
    .catch(() => {
      throw new Error("q_ajax_3 in search() failed")
    })
    .then(({data: entry_array}) => {
      const tag_id = entry_array[0].id

      // param `_embed` is required for WP JSON REST API v2
      // To fetch featured image
      this.wp_ticker_api = MarketNews.posts_api_uri().search({
        page:         "1",
        per_page:     "3",
        tags:         tag_id,
        _embed:       "",
      }).toString()
    })
    .catch((e) => {
      if (e instanceof Error) {
        throw(e)
      }
    })
  }
  // It makes news bar on ".market-news-bar", and find news data
  // from Wordpress API.
  protected fetch(){
    try{
      $().simple_ticker({
        tick_interval:    MARKET_NEWS_TICKER_INTERVAL,
        transit:          () => null,
        preprocess_json:  (obj: any[]) => {
          if (obj.length === 0){
            this.hide()
            debug("Gracefully found that there aren't any market news.")
          }
          else{
            this.render_market_news(0, obj[0])
            this.render_market_news(1, obj[1])
          }
          return obj
        },
        gen_next:         (objs: any) => circularise( objs, 1 ),
        promise_jsons:    Promise.resolve(
          q_ajax_3({
            url:      this.wp_ticker_api.toString(),
            method:   "GET",
            dataType: "json",
            // To remove default headers
            headers:  {},
          })
          .then(({data}) => data)
        ),
        promise_timeout:   3300000,
        max_retry:         6,
        on_too_much_retry: () => {
          this.hide()
          debug("Too many retrying for API fetching. Ticker bar is hidden.")
        },
      })
    }
    catch (e){
      this.hide()
    }
  }

  protected render_market_news(slot_num: number, data: WPJsonData){
    // WP JSON REST API v2
    // Does not return featured image in a simple way
    // So to comply with the template we modify the data
    // To avoid changing the template (since data structure in v2 is weird)
    //
    // Using method 2 in
    // https://medium.com/@dalenguyen/how-to-get-featured-image-from-wordpress-rest-api-5e023b9896c6
    //
    // Official doc for WP JSON REST API v2
    // https://developer.wordpress.org/rest-api/using-the-rest-api/linking-and-embedding/
    if (data._embedded != null && data._embedded["wp:featuredmedia"] != null) {
      const featured_media_entries = data._embedded["wp:featuredmedia"]
      if (featured_media_entries.length >= 1) {
        data.featured_image = {
          source: featured_media_entries[0].source_url,
        }
      }
    }

    replace_element(this.selector.image_area[slot_num], image_tmpl[slot_num], data)
    replace_element(this.selector.text_area[slot_num], text_tmpl[slot_num], data)
  }

  protected show(){
    this.$el.removeClass(HIDDEN_CLASS)
  }

  protected hide(){
    this.$el.addClass(HIDDEN_CLASS)
  }
}

const Factory = {
  create(){
    return new MarketNewsTicketSection()
  },
}

export {
  Factory,
}
